import axios from 'axios'
import qs from 'qs'
import router from '../router'
import {Toast} from 'vant'

const methods = {
  host: 'https://api.sctynews.cn',
  headers () {
    return {
      'Content-Type': 'application/json;charset=utf-8',
      'user_id': localStorage.getItem('userId') || '',
      'platformType': 'mobilePhone',
      'AUTH-TOKEN': localStorage.getItem('userToken') || ''
    }
  },

  login(data, success, fail, loading) {
    this.post('/ct/user/login-info/loginAccountAndPwd', data, success, fail, loading)
  },
  loginSendCode(data, success, fail, loading) {
    this.get('/ct/user/login-info/loginMsg', data, success, fail, loading)
  },
  phoneLogin(data, success, fail, loading) {
    this.post('/ct/user/login-info/loginPhone', data, success, fail, loading)
  },
  registerSendCode(data, success, fail, loading) {
    this.get('/ct/user/login-info/registerMsg', data, success, fail, loading)
  },
  register(data, success, fail, loading) {
    this.post('/ct/user/login-info/registerPhone', data, success, fail, loading)
  },
  getColumns(data, success, fail, loading) {
    this.post('/ct/pageconfig/column-info/getColumns', data, success, fail, loading)
  },
  getUserInfo(data, success, fail, loading) {
    this.post('/ct/user/customer-info/getUserInfo', data, success, fail, loading)
  },
  getLoopImg(data, success, fail, loading) {
    this.post('/ct/pageconfig/loop-img/getLoopImg', data, success, fail, loading)
  },
  getArticleByCol(data, success, fail, loading) {
    this.post('/ct/article/article/getArticleByCol', data, success, fail, loading)
  },
  getLiveNotice(data, success, fail, loading) {
    this.post('/ct/article/contest-notice/getLiveNotice', data, success, fail, loading)
  },
  getLiveList(data, success, fail, loading) {
    this.post('/ct/article/live-info/getLiveList', data, success, fail, loading)
  },
  addCollection(data, success, fail, loading) {
    this.get('/ct/user/collection-info/addCollection', data, success, fail, loading)
  },
  delCollection(data, success, fail, loading) {
    this.get('/ct/user/collection-info/delCollection', data, success, fail, loading)
  },
  myCollectionList(data, success, fail, loading) {
    this.post('/ct/user/collection-info/myCollectionList', data, success, fail, loading)
  },
  getArticleDetail(data, success, fail, loading) {
    this.get('/ct/article/article/getArticleDetail', data, success, fail, loading)
  },
  userSuggest(data, success, fail, loading) {
    this.post('/ct/usercenter/suggest-info/userSuggest', data, success, fail, loading)
  },
  mySuggestList(data, success, fail, loading) {
    this.post('/ct/usercenter/suggest-info/mySuggestList', data, success, fail, loading)
  },
  updatePwdByMsg(data, success, fail, loading) {
    this.post('/ct/user/customer-info/updatePwdByMsg', data, success, fail, loading)
  },
  updatePwdByMsgCheck(data, success, fail, loading) {
    this.post('/ct/user/customer-info/updatePwdByMsgCheck', data, success, fail, loading)
  },
  updatePhoneByMsg(data, success, fail, loading) {
    this.post('/ct/user/customer-info/updatePhoneByMsg', data, success, fail, loading)
  },
  updatePhoneByMsgCheck(data, success, fail, loading) {
    this.post('/ct/user/customer-info/updatePhoneByMsgCheck', data, success, fail, loading)
  },
  addPhoneByMsg(data, success, fail, loading) {
    this.post('/ct/user/customer-info/addPhoneByMsg', data, success, fail, loading)
  },
  addPhoneByMsgCheck(data, success, fail, loading) {
    this.post('/ct/user/customer-info/addPhoneByMsgCheck', data, success, fail, loading)
  },
  myCommentList(data, success, fail, loading) {
    this.post('/ct/comments/comment-info/myCommentList', data, success, fail, loading)
  },
  updateUserInfo(data, success, fail, loading) {
    this.post('/ct/user/customer-info/updateUserInfo', data, success, fail, loading)
  },
  search(data, success, fail, loading) {
    this.get('/ct/pageconfig/first-page/search', data, success, fail, loading)
  },
  getCommentByArticleId(data, success, fail, loading) {
    this.post('/ct/comments/comment-info/getCommentByArticleId', data, success, fail, loading)
  },
  comment(data, success, fail, loading) {
    this.post('/ct/comments/comment-info/comment', data, success, fail, loading)
  },
  commentPraise(data, success, fail, loading) {
    this.get('/ct/comments/comment-info/commentPraise', data, success, fail, loading)
  },
  delPraise(data, success, fail, loading) {
    this.get('/ct/comments/comment-info/delPraise', data, success, fail, loading)
  },
  myCommentList(data, success, fail, loading) {
    this.post('/ct/comments/comment-info/myCommentList', data, success, fail, loading)
  },
  uploadImg(data, success, fail, loading) {
    this.post('/manager/file/uploadImg', data, success, fail, loading)
  },
  wechatSign(data, success, fail, loading) {
    this.get('/ct/wx/wechatSign', data, success, fail, loading)
        // this.getTest('https://zwy.scleader.cn/api/chuanti-ucs/app-api/v1/sys-notice/get/wxshare/config', data, success, fail, loading)

  },
  getTest(method, data, success, fail, loading = true) {
    if (loading) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
    }
    data = data || ''
    if (data) {
      data = `?${qs.stringify(data)}`
    }
    axios({
      method: 'get',
      url: method + data,
      headers: this.headers()
    }).then((r) => {
      if (loading) {
        Toast.clear()
      }
      success(r)
    }).catch((err) => {
      fail(err)
    })
  },
  get(method, data, success, fail, loading = true) {
    if (loading) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
    }
    data = data || ''
    if (data) {
      data = `?${qs.stringify(data)}`
    }
    axios({
      method: 'get',
      url: this.host + method + data,
      headers: this.headers()
    }).then((r) => {
      if (loading) {
        Toast.clear()
      }
      success(r)
    }).catch((err) => {
      fail(err)
    })
  },
  post(method, data, success, fail, loading = true) {
    if (loading) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
    }
    data = data || {}
    axios({
      method: 'post',
      url: this.host + method,
      data: data,
      headers: this.headers()
    }).then((r) => {
      if (loading) {
        Toast.clear()
      }
      success(r)
    }).catch((err) => {
      fail(err)
    })
  }
}

export default {
  methods
}



// WEBPACK FOOTER //
// ./src/api/apis.js